<template>
  <vx-card no-shadow>
  <div class="input-container">
    <vs-input class="text-field w-full mb-base" label-placeholder="Old Password" v-model="old_password"
      v-validate="'required|min:6|max:255'" data-vv-validate-on="blur" :type="type" name="old password"/>
    <feather-icon class="icon text-center cursor-pointer" :icon="icon" color="#F9278E" svgClasses="h-5 w-5" @click="showPassword(old_password)"/>
  </div>
    <span class="text-danger text-sm">{{ errors.first('old password') }}</span>

  <div class="input-container">
    <vs-input class="w-full mb-base" label-placeholder="New Password" v-model="new_password" ref="password"
      v-validate="'required|min:6|max:255'" data-vv-validate-on="blur" :type="type" name="new password" />
      <feather-icon class="icon text-center cursor-pointer" :icon="icon" color="#F9278E" svgClasses="h-5 w-5" @click="showPassword(new_password)"/>
  </div>
    <span class="text-danger text-sm">{{ errors.first('new password') }}</span>

  <div class="input-container">
    <vs-input class="w-full mb-base" label-placeholder="Confirm Password" v-model="confirm_password" 
      v-validate="'min:6|max:255|confirmed:password'" data-vv-as="password" data-vv-validate-on="blur" :type="type" name="confirm password" />
    <feather-icon class="icon text-center cursor-pointer" :icon="icon" color="#F9278E" svgClasses="h-5 w-5" @click="showPassword(confirm_password)"/>
  </div>
    <span class="text-danger text-sm">{{ errors.first('confirm password') }}</span>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" :disabled="!changesMade" @click="changePassword">Save Changes</vs-button>
    </div>
  </vx-card>
</template>

<script>
import axios from '@/axios'
import FeatherIcon from '../../../components/FeatherIcon.vue'

export default {
  data () {
    return {
      old_password: '',
      new_password: '',
      confirm_password: '',
      type:'password',
      icon: 'EyeIcon'
    }
  },
  computed: {
    changesMade(){
      return !this.errors.any() && this.old_password !== '' && this.new_password !== '' 
    }
  },
  methods: {
    changePassword() {
      axios.patch(`user/${this.$store.state.user.id}/password/change`,{old_password: this.old_password,new_password: this.new_password})
      .then((res) => {
        this.$vs.notify({
          title: 'Success',
          text: 'Password Reset Successful!',
          iconPack: 'feather',
          icon: 'icon-check',
          color: 'success'
        })
      })
      .catch((error) => {
        this.$vs.notify({
          title: 'Failed!',
          text: error.data.errors,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })  
    },
    showPassword(value){
      if(this.type === 'password' && value !== ''){
        this.type = 'text',
        this.icon = 'EyeOffIcon'
      }else{
        this.type = 'password'
        this.icon = 'EyeIcon'
      }
    }
  }
}
</script>

<style scoped>
.input-container {
  display: -ms-flexbox; /* IE10 */
  display: flex;
  width: 100%;
}

.icon{
  padding: 10px;
  transform: translate(0,16px);
  background: #F9278E;
  color: #fff;
  height: 37px;
  border-radius: 5px;
}

.text-field{
  width: 100%;
  /* outline: none; */
}
</style>
